export const headCells = [
  {
    id: "photo",
    numeric: false,
    disablePadding: false,
    label: "Photo",
  },

  {
    id: "sku",
    numeric: false,
    disablePadding: false,
    label: "SKU",
  },

  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },

  {
    id: "status",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },

  {
    id: "category",
    numeric: false,
    disablePadding: false,
    label: "Category",
  },

  {
    id: "action",
    disablePadding: false,
    label: "Action",
  },
];
